var activeBlogTopic;
/* =====================================================
Hightlight active list item
ex: activeBlogTopic(getURLParameter("topic"))
====================================================== */
$(function(){
    activeBlogTopic = function(matchText) {
        $(".widget__link-list li").filter(function (i, el) {
            return $(el).find('a').text().toLowerCase().trim() == matchText.toLowerCase().trim();
        }).addClass('selected-topic');
    };
});
